import { Checkpoint, CheckpointView } from './Checkpoint';
import { Image, ImageView } from './Image';
import { Text, TextView } from './Text';
import { Textarea, TextareaView } from './Textarea';
import { Lora, LoraView } from './Lora';
import { Number, NumberView } from './Number';
import { Mask, MaskView } from './Mask';
import { Select, SelectView } from './Select';
import { Video, VideoView } from './Video';
import { Switch, SwitchView } from './Switch';
import { Unknown } from './Unknown';
import { Color, ColorView } from './Color';

export const fieldComponents = {
  checkpoint: Checkpoint,
  image: Image,
  text: Text,
  textarea: Textarea,
  lora: Lora,
  number: Number,
  mask: Mask,
  select: Select,
  video: Video,
  switch: Switch,
  color: Color,
};

export const fieldViewComponents = {
  checkpoint: CheckpointView,
  image: ImageView,
  text: TextView,
  textarea: TextareaView,
  lora: LoraView,
  number: NumberView,
  mask: MaskView,
  select: SelectView,
  video: VideoView,
  switch: SwitchView,
  color: ColorView,
};

export const getFieldComponent = (type) => {
  return fieldComponents[type] || Unknown;
};

export const getFieldViewComponent = (type) => {
  return fieldViewComponents[type] || Unknown;
};
